import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import config from '../../config/Constant';
import { getRequest } from '../../helpers/apiHandler';
import { formatCurrency, formatWithoutCurrency } from '../../helpers/helperFunction';
import CustomAlert from '../CustomAlert';
import SMSreportModal from './SMSreportModal';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import IconCalendar from '../../assets/SidebarIcons/icon-calendar-time.svg';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const ManagerSMSTransactionReport = () => {
    const { access_token, currency } = useSelector((state) => state.auth.user);
    const [loadingData, setLoadingData] = useState(false);
    const [search, setSearch] = useState('');
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [date, setDate] = useState([
        moment().subtract(1, 'month').startOf('day').toDate(),
        moment().toDate(),
    ]);
    const [alertState, setAlertState] = useState({
        show: false,
        variant: 'danger',
        message: '',
    });

    const onClose = () => {
        setSelectedId(null);
        setShowModal(false);
    };

    const getCreditData = () => {
        setLoadingData(true);
        const data = {
            headers: { Authorization: access_token.token },
            params: {
                start_date: date[0] ? moment(date[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss.SSSSSS') : null,
                end_date: date[1] ? moment(date[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss.SSSSSS') : null
              },
        };
        getRequest(`/admin/sms-transaction-report`, data, (res) => {
            if (res.success) {
                const result = res.data;
                setData(result);
                setSearchData(result);
                generateColumns(result);
            }
            setLoadingData(false);
        });
    };

    const openModal = (row) => {
        setSelectedId(row.user_id);
        setShowModal(true);
    };

    const sortFn = (valueA, valueB) => {
        if (valueA > valueB) {
          return 1;
        }
        return -1;
      };

    const sortName = (rowA, rowB) => {
        return sortFn(rowA.name.toUpperCase(), rowB.name.toUpperCase())
    }

    const sortTotal = (rowA, rowB) => {
        return sortFn(rowA.sent, rowB.sent)
    }

    const sortCost = (rowA, rowB) => {
        return sortFn(rowA.total_cost, rowB.total_cost)
    }

    const sortBalance = (rowA, rowB) => {
        return sortFn(rowA.available_balance, rowB.available_balance)
    }

    const generateColumns = (data) => {
        if (data.length > 0) {
            const generatedColumns = [
                {
                    name: "Name",
                    sortable: true,
                    sortFunction: sortName,
                    selector: (row) => row.name
                },
                {
                    name: "Email",
                    sortable: true,
                    selector: (row) => row.email
                },
                {
                    name: "User ID",
                    sortable: true,
                    selector: (row) => row.user_id
                },
                {
                    name: "Start Date",
                    sortable: true,
                    selector: () => moment(date[0]).startOf('day').format('MM/DD/YYYY hh:mm:ss A')
                },
                {
                    name: "End Date",
                    sortable: true,
                    selector: () => moment(date[1]).startOf('day').format('MM/DD/YYYY hh:mm:ss A')
                },
                {
                    name: "Total Message Sent",
                    sortable: true,
                    sortFunction: sortTotal,
                    selector: (row) => formatWithoutCurrency(row.sent, 0)
                },
                ...(!white_label_perkeso ? [
                    {
                        name: "Total Cost",
                        sortable: true,
                        sortFunction: sortCost,
                        selector: (row) => `${formatCurrency(currency.iso3, row.total_cost, 2)}`
                    }
                ] : []),
                ...(!white_label_perkeso ? [
                    {
                        name: "Credit Balance",
                        sortable: true,
                        sortFunction: sortBalance,
                        selector: (row) => `${formatCurrency(currency.iso3, row.available_balance, 2)}`
                    }
                ] :[
                {
                    name: "Credit Balance",
                    sortable: true,
                    sortFunction: sortBalance,
                    selector: (row) => row.available_balance
                }]),
                {
                name: 'Reports',
                minWidth: '100px',
                selector: (row) => (
                    <div className="d-flex justify-content-center align-items-center gap-1">
                        <Link onClick={() => openModal(row)} style={{ minWidth: 100 }}>
                            Detail
                        </Link>
                    </div>
                ),
            }
        ];

            setColumns(generatedColumns);
        }
    };

    const onSearch = (evt) => {
        const { value } = evt.target;
        const filteredData = data.filter(
            (item) =>
                item.name.toLowerCase().includes(value.toLowerCase()) ||
                item.email.toLowerCase().includes(value.toLowerCase())
        );

        setSearch(value);
        setSearchData(value ? filteredData : data);
    };

    useEffect(() => {
        getCreditData();
    }, [date]);

    useEffect(() => {
        if (alertState.show) {
            setTimeout(() => {
                setAlertState({
                    message: '',
                    show: false,
                    variant: '',
                });
            }, config.notify_time);
        }
    }, [alertState]);

    return (
        <div className="w-100">
            <div className="page-heading admin-heading">
                <div className="container-left" style={{ marginBottom: "32px"}}>
                    <div className="page-title">SMS Transaction Report</div>
                </div>
                <div className="w-100 d-flex justify-content-between">
                    <div className='left-section w-50'>
                        <InputGroup className="datatable-search search-input">
                            <InputGroup.Append className={focus ? 'input-focus' : ''}>
                                <InputGroup.Text>
                                    <img alt="..." src={searchIcon} />
                                </InputGroup.Text>
                            </InputGroup.Append>
                            <Form.Control
                                placeholder="Search..."
                                name="search"
                                value={search}
                                onChange={onSearch}
                                className="search-form"
                            />
                        </InputGroup>
                    </div>
                    <div className='right-section'>
                    <DateRangePicker
                      className="campaign-analytic-date-picker"
                      value={date}
                      onChange={setDate}
                      clearIcon={null}
                      calendarIcon={<img src={IconCalendar} alt="..." />}
                      format="MM-dd-y"
                      rangeDivider={<i className="fas fa-long-arrow-alt-right" />}
                      dayPlaceholder="DD"
                      monthPlaceholder="MM"
                      yearPlaceholder="YYYY"
                    />
                    </div>
                </div>
            </div>
            <CustomAlert
                message={alertState.message}
                show={alertState.show}
                variant={alertState.variant}
                closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
            />
            <DataTable
                columns={columns}
                data={searchData}
                progressPending={loadingData}
                paginationComponentOptions={{
                    rowsPerPageText: 'Items per page:',
                }}
                pagination
            />
            <SMSreportModal
                show={showModal}
                onClose={onClose}
                access_token={access_token}
                user_id={selectedId}
                date={date}
                setDate={setDate}
            />
        </div>
    );
};

export default ManagerSMSTransactionReport;
